import React from "react";
import { NavLink, useParams } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DescriptionIcon from "@material-ui/icons/Description";
import GroupIcon from "@material-ui/icons/Group";
import * as Glob from "../../Globale";
import { Trad } from "../../components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _CoobligatedListForm, _InfoSection } from "../components";
import { _Autocomplete, _DateField, _Select } from "../form";

export interface IRouteParam {
    ID_FideAffidamento: string;
    ID_Polizza?: string;
}

export const _BondsCoobligated: React.FC<Glob.IRouteGlobaleProps> = props => {
    const ID_Polizza = useParams<IRouteParam>().ID_Polizza || "";
    const ID_FideAffidamento = !ID_Polizza ? useParams<IRouteParam>().ID_FideAffidamento : "";

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={GroupIcon} Title="Coobbligati">
                    {(ID_Polizza || (ID_FideAffidamento && Number(ID_FideAffidamento) > 0)) && (
                        <a href={`/file/${ID_Polizza || ID_FideAffidamento}`}>
                            <Tooltip title={Trad.Trad("Documenti")}>
                                <IconButton size="small" aria-label="add">
                                    <DescriptionIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {ID_Polizza && <_InfoSection DataUrl={`/api/polizza/Contesto?ID_Polizza=${ID_Polizza}`} Title="Polizza" />}
                            {ID_FideAffidamento && <_InfoSection DataUrl={`/api/fideaffidamento/Contesto?ID_FideAffidamento=${ID_FideAffidamento}`} Title="Affidamento" />}
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <_CoobligatedListForm ID_Polizza={ID_Polizza} ID_FideAffidamento={ID_FideAffidamento} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/BondsCoobligated.tsx